import { dashboardRoutesDefinitions } from '@/routes-definitions';

export const dashboardRoutes = [
  {
    path: dashboardRoutesDefinitions.home.path,
    name: dashboardRoutesDefinitions.home.name,
    component: () => import('./pages/HomePage.vue')
  },
  {
    path: dashboardRoutesDefinitions.faq.path,
    name: dashboardRoutesDefinitions.faq.name,
    component: () => import('./pages/FAQPage.vue')
  }
];
